import { render, staticRenderFns } from "./HuanbeiVisitor.vue?vue&type=template&id=4b25a866&scoped=true&"
import script from "./HuanbeiVisitor.vue?vue&type=script&lang=js&"
export * from "./HuanbeiVisitor.vue?vue&type=script&lang=js&"
import style0 from "./HuanbeiVisitor.vue?vue&type=style&index=0&id=4b25a866&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b25a866",
  null
  
)

export default component.exports